/**
 * CSS Constants
 */
/** @private */
export const ROOT = 'e-schedule';
/** @private */
export const RTL = 'e-rtl';
/** @private */
export const DEVICE_CLASS = 'e-device';
/** @private */
export const ADAPTIVE_CLASS = 'e-adaptive';
/** @private */
export const MULTI_DRAG = 'e-multi-drag';
/** @private */
export const ICON = 'e-icons';
/** @private */
export const ENABLE_CLASS = 'e-enable';
/** @private */
export const DISABLE_CLASS = 'e-disable';
/** @private */
export const TABLE_CONTAINER_CLASS = 'e-table-container';
/** @private */
export const SCHEDULE_TABLE_CLASS = 'e-schedule-table';
/** @private */
export const ALLDAY_CELLS_CLASS = 'e-all-day-cells';
/** @private */
export const HEADER_POPUP_CLASS = 'e-header-popup';
/** @private */
export const HEADER_CALENDAR_CLASS = 'e-header-calendar';
/** @private */
export const ALLDAY_ROW_CLASS = 'e-all-day-row';
/** @private */
export const CONTENT_TABLE_CLASS = 'e-content-table';
/** @private */
export const WORK_CELLS_CLASS = 'e-work-cells';
/** @private */
export const WORK_HOURS_CLASS = 'e-work-hours';
/** @private */
export const POPUP_OPEN = 'e-popup-open';
/** @private */
export const POPUP_CLOSE = 'e-popup-close';
/** @private */
export const DATE_HEADER_WRAP_CLASS = 'e-date-header-wrap';
/** @private */
export const DATE_HEADER_CONTAINER_CLASS = 'e-date-header-container';
/** @private */
export const HEADER_CELLS_CLASS = 'e-header-cells';
/** @private */
export const HEADER_WEEK_CELLS_CLASS = 'e-header-week-cell';
/** @private */
export const HEADER_MONTH_CELLS_CLASS = 'e-header-month-cell';
/** @private */
export const HEADER_YEAR_CELLS_CLASS = 'e-header-year-cell';
/** @private */
export const WORKDAY_CLASS = 'e-work-days';
/** @private */
export const OTHERMONTH_CLASS = 'e-other-month';
/** @private */
export const CURRENT_DAY_CLASS = 'e-current-day';
/** @private */
export const CURRENTDATE_CLASS = 'e-current-date';
/** @private */
export const CURRENT_PANEL_CLASS = 'e-current-panel';
/** @private */
export const PREVIOUS_PANEL_CLASS = 'e-previous-panel';
/** @private */
export const NEXT_PANEL_CLASS = 'e-next-panel';
/** @private */
export const PREVIOUS_DATE_CLASS = 'e-prev';
/** @private */
export const NEXT_DATE_CLASS = 'e-next';
/** @private */
export const TRANSLATE_CLASS = 'e-translate';
/** @private */
export const LEFT_INDENT_CLASS = 'e-left-indent';
/** @private */
export const LEFT_INDENT_WRAP_CLASS = 'e-left-indent-wrap';
/** @private */
export const EVENT_TABLE_CLASS = 'e-event-table';
/** @private */
export const RESOURCE_LEFT_TD_CLASS = 'e-resource-left-td';
/** @private */
export const RESOURCE_GROUP_CELLS_CLASS = 'e-resource-group-cells';
/** @private */
export const RESOURCE_TEXT_CLASS = 'e-resource-text';
/** @private */
export const RESOURCE_COLUMN_WRAP_CLASS = 'e-resource-column-wrap';
/** @private */
export const RESOURCE_COLUMN_TABLE_CLASS = 'e-resource-column-table';
/** @private */
export const RESOURCE_CHILD_CLASS = 'e-child-node';
/** @private */
export const RESOURCE_PARENT_CLASS = 'e-parent-node';
/** @private */
export const RESOURCE_EXPAND_CLASS = 'e-resource-expand';
/** @private */
export const RESOURCE_COLLAPSE_CLASS = 'e-resource-collapse';
/** @private */
export const RESOURCE_TREE_ICON_CLASS = 'e-resource-tree-icon';
/** @private */
export const RESOURCE_CELLS_CLASS = 'e-resource-cells';
/** @private */
export const TIME_CELLS_WRAP_CLASS = 'e-time-cells-wrap';
/** @private */
export const TIME_CELLS_CLASS = 'e-time-cells';
/** @private */
export const TIME_SLOT_CLASS = 'e-time-slots';
/** @private */
export const ALTERNATE_CELLS_CLASS = 'e-alternate-cells';
/** @private */
export const CURRENT_TIME_CLASS = 'e-current-time';
/** @private */
export const CURRENT_TIMELINE_CLASS = 'e-current-timeline';
/** @private */
export const PREVIOUS_TIMELINE_CLASS = 'e-previous-timeline';
/** @private */
export const HIDE_CHILDS_CLASS = 'e-hide-childs';
/** @private */
export const SCROLL_CONTAINER_CLASS = 'e-scroll-container';
/** @private */
export const WRAPPER_CLASS = 'e-wrapper';
/** @private */
export const TIMELINE_WRAPPER_CLASS = 'e-timeline-wrapper';
/** @private */
export const APPOINTMENT_WRAPPER_CLASS = 'e-appointment-wrapper';
/** @private */
export const APPOINTMENT_WRAPPER_HIDDEN_CLASS = 'e-appointment-wrapper-hidden';
/** @private */
export const DAY_WRAPPER_CLASS = 'e-day-wrapper';
/** @private */
export const TOOLBAR_CONTAINER = 'e-schedule-toolbar-container';
/** @private */
export const RESOURCE_TOOLBAR_CONTAINER = 'e-schedule-resource-toolbar-container';
/** @private */
export const HEADER_TOOLBAR = 'e-schedule-toolbar';
/** @private */
export const RESOURCE_HEADER_TOOLBAR = 'e-schedule-resource-toolbar';
/** @private */
export const SELECTED_CELL_CLASS = 'e-selected-cell';
/** @private */
export const WEEK_NUMBER_WRAPPER_CLASS = 'e-week-number-wrapper';
/** @private */
export const WEEK_NUMBER_CLASS = 'e-week-number';
/** @private */
export const APPOINTMENT_WRAP_CLASS = 'e-appointment-wrap';
/** @private */
export const WRAPPER_CONTAINER_CLASS = 'e-wrapper-container';
/** @private */
export const APPOINTMENT_CONTAINER_CLASS = 'e-appointment-container';
/** @private */
export const APPOINTMENT_CLASS = 'e-appointment';
/** @private */
export const BLOCK_APPOINTMENT_CLASS = 'e-block-appointment';
/** @private */
export const BLOCK_INDICATOR_CLASS = 'e-block-indicator';
/** @private */
export const APPOINTMENT_BORDER = 'e-appointment-border';
/** @private */
export const APPOINTMENT_DETAILS = 'e-appointment-details';
/** @private */
export const SUBJECT_WRAP = 'e-subject-wrap';
/** @private */
export const RESOURCE_NAME = 'e-resource-name';
/** @private */
export const APPOINTMENT_TIME = 'e-time';
/** @private */
export const TABLE_WRAP_CLASS = 'e-table-wrap';
/** @private */
export const OUTER_TABLE_CLASS = 'e-outer-table';
/** @private */
export const CONTENT_WRAP_CLASS = 'e-content-wrap';
/** @private */
export const VIRTUAL_TRACK_CLASS = 'e-virtual-track';
/** @private */
export const AGENDA_CELLS_CLASS = 'e-agenda-cells';
/** @private */
export const AGENDA_CURRENT_DAY_CLASS = 'e-current-day';
/** @private */
export const AGENDA_SELECTED_CELL = 'e-active-appointment-agenda';
/** @private */
export const MONTH_HEADER_CLASS = 'e-month-header';
/** @private */
export const AGENDA_HEADER_CLASS = 'e-day-date-header';
/** @private */
export const AGENDA_RESOURCE_CLASS = 'e-resource-column';
/** @private */
export const AGENDA_DATE_CLASS = 'e-date-column';
/** @private */
export const NAVIGATE_CLASS = 'e-navigate';
/** @private */
export const DATE_HEADER_CLASS = 'e-date-header';
/** @private */
export const AGENDA_DAY_BORDER_CLASS = 'e-day-border';
/** @private */
export const DATE_BORDER_CLASS = 'e-date-border';
/** @private */
export const AGENDA_DAY_PADDING_CLASS = 'e-day-padding';
/** @private */
export const DATE_TIME_CLASS = 'e-date-time';
/** @private */
export const DATE_TIME_WRAPPER_CLASS = 'e-date-time-wrapper';
/** @private */
export const AGENDA_EMPTY_EVENT_CLASS = 'e-empty-event';
/** @private */
export const AGENDA_NO_EVENT_CLASS = 'e-no-event';
/** @private */
export const APPOINTMENT_INDICATOR_CLASS = 'e-appointment-indicator';
/** @private */
export const EVENT_INDICATOR_CLASS = 'e-indicator';
/** @private */
export const EVENT_ICON_UP_CLASS = 'e-up-icon';
/** @private */
export const EVENT_ICON_DOWN_CLASS = 'e-down-icon';
/** @private */
export const EVENT_ICON_LEFT_CLASS = 'e-left-icon';
/** @private */
export const EVENT_ICON_RIGHT_CLASS = 'e-right-icon';
/** @private */
export const EVENT_ACTION_CLASS = 'e-event-action';
/** @private */
export const NEW_EVENT_CLASS = 'e-new-event';
/** @private */
export const CLONE_ELEMENT_CLASS = 'e-schedule-event-clone';
/** @private */
export const MONTH_CLONE_ELEMENT_CLASS = 'e-month-event';
/** @private */
export const CLONE_TIME_INDICATOR_CLASS = 'e-clone-time-indicator';
/** @private */
export const DRAG_CLONE_CLASS = 'e-drag-clone';
/** @private */
export const EVENT_RESIZE_CLASS = 'e-event-resize';
/** @private */
export const RESIZE_CLONE_CLASS = 'e-resize-clone';
/** @private */
export const LEFT_RESIZE_HANDLER = 'e-left-handler';
/** @private */
export const RIGHT_RESIZE_HANDLER = 'e-right-handler';
/** @private */
export const TOP_RESIZE_HANDLER = 'e-top-handler';
/** @private */
export const BOTTOM_RESIZE_HANDLER = 'e-bottom-handler';
/** @private */
export const EVENT_RECURRENCE_ICON_CLASS = 'e-recurrence-icon';
/** @private */
export const EVENT_RECURRENCE_EDIT_ICON_CLASS = 'e-recurrence-edit-icon';
/** @private */
export const HEADER_ROW_CLASS = 'e-header-row';
/** @private */
export const ALLDAY_APPOINTMENT_WRAPPER_CLASS = 'e-all-day-appointment-wrapper';
/** @private */
export const ALLDAY_APPOINTMENT_CLASS = 'e-all-day-appointment';
/** @private */
export const EVENT_COUNT_CLASS = 'e-appointment-hide';
/** @private */
export const ROW_COUNT_WRAPPER_CLASS = 'e-row-count-wrapper';
/** @private */
export const ALLDAY_APPOINTMENT_SECTION_CLASS = 'e-all-day-appointment-section';
/** @private */
export const APPOINTMENT_ROW_EXPAND_CLASS = 'e-appointment-expand';
/** @private */
export const APPOINTMENT_ROW_COLLAPSE_CLASS = 'e-appointment-collapse';
/** @private */
export const MORE_INDICATOR_CLASS = 'e-more-indicator';
/** @private */
export const CELL_POPUP_CLASS = 'e-cell-popup';
/** @private */
export const EVENT_POPUP_CLASS = 'e-event-popup';
/** @private */
export const MULTIPLE_EVENT_POPUP_CLASS = 'e-multiple-event-popup';
/** @private */
export const POPUP_HEADER_CLASS = 'e-popup-header';
/** @private */
export const POPUP_HEADER_ICON_WRAPPER = 'e-header-icon-wrapper';
/** @private */
export const POPUP_CONTENT_CLASS = 'e-popup-content';
/** @private */
export const POPUP_FOOTER_CLASS = 'e-popup-footer';
/** @private */
export const DATE_TIME_DETAILS_CLASS = 'e-date-time-details';
/** @private */
export const RECURRENCE_SUMMARY_CLASS = 'e-recurrence-summary';
/** @private */
export const QUICK_POPUP_EVENT_DETAILS_CLASS = 'e-event-details';
/** @private */
export const EVENT_CREATE_CLASS = 'e-event-create';
/** @private */
export const EDIT_EVENT_CLASS = 'e-event-edit';
/** @private */
export const DELETE_EVENT_CLASS = 'e-event-delete';
/** @private */
export const TEXT_ELLIPSIS = 'e-text-ellipsis';
/** @private */
export const MORE_POPUP_WRAPPER_CLASS = 'e-more-popup-wrapper';
/** @private */
export const MORE_EVENT_POPUP_CLASS = 'e-more-event-popup';
/** @private */
export const MORE_EVENT_HEADER_CLASS = 'e-more-event-header';
/** @private */
export const MORE_EVENT_DATE_HEADER_CLASS = 'e-more-event-date-header';
/** @private */
export const MORE_EVENT_HEADER_DAY_CLASS = 'e-header-day';
/** @private */
export const MORE_EVENT_HEADER_DATE_CLASS = 'e-header-date';
/** @private */
export const MORE_EVENT_CLOSE_CLASS = 'e-more-event-close';
/** @private */
export const MORE_EVENT_CONTENT_CLASS = 'e-more-event-content';
/** @private */
export const MORE_EVENT_WRAPPER_CLASS = 'e-more-appointment-wrapper';
/** @private */
export const QUICK_DIALOG_CLASS = 'e-quick-dialog';
/** @private */
export const QUICK_DIALOG_OCCURRENCE_CLASS = 'e-quick-dialog-occurrence-event';
/** @private */
export const QUICK_DIALOG_SERIES_CLASS = 'e-quick-dialog-series-event';
/** @private */
export const QUICK_DIALOG_FOLLOWING_EVENTS_CLASS = 'e-quick-dialog-following-events';
/** @private */
export const FOLLOWING_EVENTS_DIALOG = 'e-following-events-dialog';
/** @private */
export const QUICK_DIALOG_DELETE_CLASS = 'e-quick-dialog-delete';
/** @private */
export const QUICK_DIALOG_CANCEL_CLASS = 'e-quick-dialog-cancel';
/** @private */
export const QUICK_DIALOG_ALERT_OK = 'e-quick-alertok';
/** @private */
export const QUICK_DIALOG_ALERT_CANCEL = 'e-quick-alertcancel';
/** @private */
export const QUICK_DIALOG_ALERT_FOLLOWING = 'e-quick-alertfollowing';
/** @private */
export const QUICK_DIALOG_ALERT_BTN_CLASS = 'e-quick-dialog-alert-btn';
/** @private */
export const EVENT_WINDOW_DIALOG_CLASS = 'e-schedule-dialog';
/** @private */
export const FORM_CONTAINER_CLASS = 'e-form-container';
/** @private */
export const FORM_CLASS = 'e-schedule-form';
/** @private */
export const EVENT_WINDOW_ALLDAY_TZ_DIV_CLASS = 'e-all-day-time-zone-row';
/** @private */
export const EVENT_WINDOW_ALL_DAY_CLASS = 'e-all-day';
/** @private */
export const TIME_ZONE_CLASS = 'e-time-zone';
/** @private */
export const TIME_ZONE_ICON_CLASS = 'e-time-zone-icon';
/** @private */
export const TIME_ZONE_DETAILS_CLASS = 'e-time-zone-details';
/** @private */
export const EVENT_WINDOW_REPEAT_DIV_CLASS = 'e-repeat-parent-row';
/** @private */
export const EVENT_WINDOW_REPEAT_CLASS = 'e-repeat';
/** @private */
export const EVENT_WINDOW_TITLE_LOCATION_DIV_CLASS = 'e-title-location-row';
/** @private */
export const SUBJECT_CLASS = 'e-subject';
/** @private */
export const LOCATION_CLASS = 'e-location';
/** @private */
export const LOCATION_ICON_CLASS = 'e-location-icon';
/** @private */
export const LOCATION_DETAILS_CLASS = 'e-location-details';
/** @private */
export const EVENT_WINDOW_START_END_DIV_CLASS = 'e-start-end-row';
/** @private */
export const EVENT_WINDOW_START_CLASS = 'e-start';
/** @private */
export const EVENT_WINDOW_END_CLASS = 'e-end';
/** @private */
export const EVENT_WINDOW_RESOURCES_DIV_CLASS = 'e-resources-row';
/** @private */
export const DESCRIPTION_CLASS = 'e-description';
/** @private */
export const DESCRIPTION_ICON_CLASS = 'e-description-icon';
/** @private */
export const DESCRIPTION_DETAILS_CLASS = 'e-description-details';
/** @private */
export const EVENT_WINDOW_TIME_ZONE_DIV_CLASS = 'e-time-zone-row';
/** @private */
export const EVENT_WINDOW_START_TZ_CLASS = 'e-start-time-zone';
/** @private */
export const EVENT_WINDOW_END_TZ_CLASS = 'e-end-time-zone';
/** @private */
export const EVENT_WINDOW_BACK_ICON_CLASS = 'e-back-icon';
/** @private */
export const EVENT_WINDOW_SAVE_ICON_CLASS = 'e-save-icon';
/** @private */
export const EVENT_WINDOW_CANCEL_BUTTON_CLASS = 'e-event-cancel';
/** @private */
export const EVENT_WINDOW_SAVE_BUTTON_CLASS = 'e-event-save';
/** @private */
export const EVENT_WINDOW_DIALOG_PARENT_CLASS = 'e-dialog-parent';
/** @private */
export const EVENT_WINDOW_TITLE_TEXT_CLASS = 'e-title-text';
/** @private */
export const EVENT_WINDOW_ICON_DISABLE_CLASS = 'e-icon-disable';
/** @private */
export const EDIT_CLASS = 'e-edit';
/** @private */
export const EDIT_ICON_CLASS = 'e-edit-icon';
/** @private */
export const DELETE_CLASS = 'e-delete';
/** @private */
export const DELETE_ICON_CLASS = 'e-delete-icon';
/** @private */
export const CLOSE_CLASS = 'e-close';
/** @private */
export const CLOSE_ICON_CLASS = 'e-close-icon';
/** @private */
export const ERROR_VALIDATION_CLASS = 'e-schedule-error';
/** @private */
export const EVENT_TOOLTIP_ROOT_CLASS = 'e-schedule-event-tooltip';
/** @private */
export const ALLDAY_ROW_ANIMATE_CLASS = 'e-animate';
/** @private */
export const TIMESCALE_DISABLE = 'e-timescale-disable';
/** @private */
export const DISABLE_DATE = 'e-disable-date';
/** @private */
export const HIDDEN_CLASS = 'e-hidden';
/** @private */
export const DISABLE_DATES = 'e-disable-dates';
/** @private */
export const POPUP_WRAPPER_CLASS = 'e-quick-popup-wrapper';
/** @private */
export const POPUP_TABLE_CLASS = 'e-popup-table';
/** @private */
export const RESOURCE_MENU = 'e-resource-menu';
/** @private */
export const RESOURCE_MENU_ICON = 'e-icon-menu';
/** @private */
export const RESOURCE_LEVEL_TITLE = 'e-resource-level-title';
/** @private */
export const RESOURCE_TREE = 'e-resource-tree';
/** @private */
export const RESOURCE_TREE_POPUP_OVERLAY = 'e-resource-tree-popup-overlay';
/** @private */
export const RESOURCE_TREE_POPUP = 'e-resource-tree-popup';
/** @private */
export const RESOURCE_CLASS = 'e-resource';
/** @private */
export const RESOURCE_ICON_CLASS = 'e-resource-icon';
/** @private */
export const RESOURCE_DETAILS_CLASS = 'e-resource-details';
/** @private */
export const DATE_TIME_ICON_CLASS = 'e-date-time-icon';
/** @private */
export const VIRTUAL_SCROLL_CLASS = 'e-virtual-scroll';
/** @private */
export const ICON_DISABLE_CLASS = 'e-icon-disable';
/** @private */
export const AUTO_HEIGHT = 'e-auto-height';
/** @private */
export const IGNORE_WHITESPACE = 'e-ignore-whitespace';
/** @private */
export const EVENT_TEMPLATE = 'e-template';
/** @private */
export const READ_ONLY = 'e-read-only';
/** @private */
export const MONTH_HEADER_WRAPPER = 'e-month-header-wrapper';
/** @private */
export const INLINE_SUBJECT_CLASS = 'e-inline-subject';
/** @private */
export const INLINE_APPOINTMENT_CLASS = 'e-inline-appointment';
/** @hidden */
export const SCROLL_HIDDEN = 'e-scroll-hidden';
/** @private */
export const ALLDAY_APPOINTMENT_SCROLL = 'e-all-day-scroll';
/** @private */
export const ALLDAY_APPOINTMENT_AUTO = 'e-all-day-auto';
/** @private */
export const CLIPBOARD_CLASS = 'e-clipboard';
